import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {randomUUIDGenerator} from 'app/core/helpers/uuid';
import {DropDownOption} from 'app/shared/components/drop-down-list/drop-down-list.component';
import {Subject} from 'rxjs';

@Component({
    selector: 'list-option',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListOptionComponent implements DropDownOption, OnChanges {
    @Input() value: any;
    @Input() label: string;
    @Input() icon: string;
    @Input() svgImage: string;
    @Input() disabledOption: boolean;
    changed$ = new Subject();
    id = randomUUIDGenerator();

    ngOnChanges() {
        this.changed$.next();
    }
}
